import { render } from "./our-client.vue?vue&type=template&id=5dd1ad1f&scoped=true"
import script from "./our-client.vue?vue&type=script&lang=js"
export * from "./our-client.vue?vue&type=script&lang=js"

import "./our-client.vue?vue&type=style&index=0&id=5dd1ad1f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5dd1ad1f"

export default script